var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRotate = function SvgRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M14.997 9a1 1 0 0 1 0-2l3.479-.001-2.817-2.653a8 8 0 0 0-9.266-1.485l-.255.135a8 8 0 1 0 11.406 9.67 1 1 0 1 1 1.886.667A10 10 0 1 1 5.172 1.244c3.9-2.15 8.754-1.462 11.88 1.668l2.944 2.771V2a1 1 0 0 1 .884-.994L20.997 1a1 1 0 0 1 1 1v6a1 1 0 0 1-.118.47 1 1 0 0 1-.057.095 1 1 0 0 1-.097.12l.066-.077-.04.049-.026.028a1 1 0 0 1-.443.273 1 1 0 0 1-.285.042l.104-.006-.066.005h-.038Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "currentColor",
    fillRule: "evenodd",
    transform: "translate(1 2)"
  })));
};
export default SvgRotate;